import { cn } from "@gymflow/helpers";
import { cva, VariantProps } from "class-variance-authority";

const badgeVariants = cva(
  "inline-flex w-fit items-center rounded-md px-2 py-1 text-xs font-bold ring-1 ring-inset",
  {
    variants: {
      intent: {
        success: "bg-success-50 text-success-700 dark:text-success-300 dark:ring-success-800 ring-success-200",
        warning: "bg-warning-50 text-warning-700 dark:text-warning-300 dark:ring-warning-800 ring-warning-200",
        error: "bg-error-50 text-error-700 dark:text-error-300 dark:ring-error-800 ring-error-200",
        primary: "bg-primary-50 text-primary-700 dark:text-primary-300 dark:ring-primary-800 ring-primary-200",
        secondary: "bg-secondary-50 text-secondary-700 dark:text-secondary-300 dark:ring-secondary-800 ring-secondary-200",
        transparent: "bg-transparent text-gray-900 ring-0 dark:text-gray-200",
        default:
          "bg-gray-50 text-gray-950 ring-gray-300 dark:bg-gray-700 dark:text-gray-400 dark:ring-gray-700",
      },
    },
    defaultVariants: {
      intent: "default",
    },
  },
);

export interface BadgeProps
  extends Omit<React.HTMLProps<HTMLSpanElement>, "type">,
    VariantProps<typeof badgeVariants> {}

export function Badge({ children, className, intent, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ intent }), className)} {...props}>
      {children}
    </span>
  );
}
